<div
  class="grid mb-3"
  [ngClass]="title ? 'justify-content-between' : 'justify-content-end'"
>
  <span *ngIf="title" class="flex col-12 md:col-fixed md:w-auto">
    <button
      [routerLink]="backTo"
      *ngIf="showGoBack"
      class="mr-2"
      mat-icon-button
      type="button"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="inline-block">
      {{ title | capitalize }}
    </h1>
  </span>
  <div *ngIf="rightContent" class="col-12 md:col-fixed md:w-auto">
    <ng-container *ngTemplateOutlet="rightContent"></ng-container>
  </div>
</div>
